/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import Grid from "@mui/material/Grid";

import MDBox, { Props } from "dashboard-template/components/MDBox";

import DashboardLayout from "dashboard-template/examples/LayoutContainers/DashboardLayout";
import Footer from "layouts/dashboard/DashboardFooter";

import DashboardNavbar from "layouts/dashboard/DashboardNavbar";
import { useNavigate } from "react-router-dom";

import { isUserLogged } from "utils/http.utils";
import { authAction, useAppDispatch } from "store/store";

import { SnackbarProvider } from "notistack";
import DashboardMessages from "./DashboardMessages";
import { RoutesConstants } from "medicalsystem-shared";
import { useEffect } from "react";

/**
 * Default dashboard layout container with authentication guard.
 * 
 * Provides:
 * - Authentication check on mount with redirect to login if not authenticated
 * - Dashboard layout wrapper with navbar, footer, and content area
 * - Snackbar notifications provider (max 5 notifications, 5s auto-hide)
 * - Dashboard messages integration
 * - Grid container for page content with centered alignment
 * 
 * This layout is used by all authenticated dashboard pages and enforces
 * user authentication before rendering child components. If the user is not
 * logged in, they are redirected to the login page.
 * 
 * @param props.children - Page content to render inside the dashboard layout
 * @returns Dashboard layout with authentication guard
 */
const DefaultDashboardLayout: React.FC<Props> = (props) => {
  // Auth checked
  const navigate = useNavigate();
  const dispatchLogged = useAppDispatch();

  useEffect(() => {
    if (isUserLogged()) {
      dispatchLogged(authAction.syncStoredUser());
    } else {
      navigate(RoutesConstants.LOGIN, { replace: true });
    }
  }, [dispatchLogged, navigate]);

  return (
    <SnackbarProvider maxSnack={5} autoHideDuration={5000}>
      <DashboardLayout {...props}>
        <DashboardNavbar />
        <MDBox py={3}>
          <DashboardMessages />
          <Grid className="data-view-container" justifyContent="center" alignItems="center">
            {props.children}
          </Grid>
        </MDBox>
        <Footer />
      </DashboardLayout>
    </SnackbarProvider>
  );
};

export default DefaultDashboardLayout;

